import {Component, OnInit} from '@angular/core';
import {APIService} from "../../services/APIService";
import {ActivatedRoute, Router} from "@angular/router";
import {CookieService} from "ngx-cookie-service";
import {AuthService} from "../../services/AuthService";
import {MatDialog} from "@angular/material/dialog";
import {TwofactorComponent} from "./twofactor/twofactor.component";

export interface NavItem {
  name: string;
  icon: string;
  url: string;
  permission?: string;
}

export interface NavCategory {
  name: string;
  items: NavItem[];
}

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  public nav: NavCategory[] = [
    {
      name: "Panel",
      items: [{
        name: "Home",
        icon: "home",
        url: "/"
      }]
    },
    {
      name: "Players",
      items: [
        {
          name: "Players",
          icon: "person",
          url: "/players"
        },
        {
          name: "Punishments",
          icon: "gavel",
          url: "/punishments"
        },
        {
          name: "Rank List",
          icon: "receipt_long",
          url: "/rank/list"
        },
        {
          name: "Create",
          icon: "add_circle",
          url: "create",
          permission: "OPERATIONS"
        }]
    },
    {
      name: "Event",
      items: [
        {
          name: "Schedule",
          icon: "schedule",
          url: "/schedule",
          permission: "OPERATIONS"
        },
        {
          name: "Servers",
          icon: "dns",
          url: "/servers/list",
          permission: "OPERATIONS"
        }
      ]
    },
    {
      name: "Assets",
      items: [
        {
          name: "Booths",
          icon: "museum",
          url: "/booths/list",
          permission: "OPERATIONS"
        },
        {
          name: "Resource Packs",
          icon: "archive",
          url: "/resources/packs",
          permission: "OPERATIONS"
        }
        ]
    },
    {
      name: "Server",
      items: [
        {
          name: "Staff Activity",
          icon: "support_agent",
          url: "/activity",
          permission: "OPERATIONS"
        },
        {
          name: "Map Images",
          icon: "map",
          url: "/resources/map-images",
          permission: "OPERATIONS"
        },
        {
          name: "Announces",
          icon: "campaign",
          url: "/announces/list",
          permission: "OPERATIONS"
        },
        {
          name: "Whitelist",
          icon: "key",
          url: "/ac",
          permission: "OPERATIONS"
        },
        {
          name: "Scavenger",
          icon: "search",
          url: "/scavenger",
          permission: "OPERATIONS"
        },
        {
          name: "Quiz",
          icon: "question_mark",
          url: "/quiz/list",
          permission: "OPERATIONS"
        }
      ]
    }
  ]

  constructor(public apiService: APIService,
              private route: ActivatedRoute,
              private router: Router,
              private cookieService: CookieService,
              public authService: AuthService,
              public dialog: MatDialog) {

  }

  in2fa: boolean = false;

  promptTwoFactor(ip: string) {
    this.apiService.getIpInfo(ip).then((info) => {
      this.in2fa = true;
      this.dialog.open(TwofactorComponent, {data: info, width: "30vw", autoFocus: "dialog"})
        .afterClosed().subscribe((a) => {
          this.in2fa = false;
      })
    })
  }

  check() {
    this.apiService.check2fa().then((a) => {
      if(a.length !== 0 && !this.in2fa)
        this.promptTwoFactor(a);
    })
  }

  ngOnInit() {
    //this.check()
    //setInterval(() => {
    //  this.check();
    //}, 5000);
  }

}
